import { createContext } from 'react';
import { DataRoomShareableLink } from 'models/ShareableLink';
import utils from 'utils';

type CreateShareableLinkContextProps = {
  openCreateShareableLink: (filesId?: string[]) => void;
  openCreateShareableLinkWithTemplate: (
    link: DataRoomShareableLink & { dataRoomShareableLinkRequestId?: string },
  ) => void;
};

export default createContext<Partial<CreateShareableLinkContextProps>>({
  openCreateShareableLink: utils.noop,
  openCreateShareableLinkWithTemplate: utils.noop,
});
